import request from "../utils/request"

export function fetchPetList(ownerUserId) {
  return request({
    url: "/pets/manage",
    method: "get",
    params: ownerUserId ? { ownerUserId } : {}
  })
}

export function fetchPetOwner(userId) {
  return request({
    url: `/users/${userId}`,
    method: "get"
  })
}

export function fetchPublicPetTypeTree() {
  return request({
    url: "/pet-types/tree",
    method: "get"
  })
}

export function createPetForUser(data) {
  return request({
    url: "/pets/manage",
    method: "post",
    data
  })
}

export function parsePetsFromImage(file) {
  const data = new FormData()
  data.append("file", file)
  return request({
    url: "/pets/manage/ai-parse",
    method: "post",
    data,
    timeout: 120000,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

export function uploadPetImage(file) {
  const data = new FormData()
  data.append("file", file)
  return request({
    url: "/pets/cover/upload",
    method: "post",
    data,
    timeout: 60000,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

export function fetchPetCareRecords(openId, petId) {
  return request({
    url: "/care-records",
    method: "get",
    params: {
      openId,
      petId,
      todayOnly: false,
      limit: 30
    }
  })
}

export function fetchPetWeightRecords(openId, petId) {
  return request({
    url: "/pet-weight-records",
    method: "get",
    params: {
      openId,
      petId,
      limit: 30
    }
  })
}

export function fetchPetCostRecords(openId, petId) {
  return request({
    url: "/pet-cost-records",
    method: "get",
    params: {
      openId,
      petId,
      limit: 30
    }
  })
}

export function fetchPetCostSummary(openId, petId) {
  return request({
    url: "/pet-cost-records/summary",
    method: "get",
    params: {
      openId,
      petId
    }
  })
}

export function fetchPetFeedingPlan(ownerUserId, petId) {
  return request({
    url: "/pet-feeding-plans/current",
    method: "get",
    params: {
      ownerUserId,
      petId
    }
  })
}
